export default __webpack_public_path__ + "static/media/docker.b83c8670.png";